import { useSelector } from 'react-redux'
import { selectIsNonUsCountry } from '@store/signup'
import { CybersecurityBanner } from '../CybersecurityBanner'
import { UserMenu } from './UserMenu'
import { Logo } from '../Logo'
import * as S from './styled'

interface HeaderProps {
  screenId: string,
  defaultState?: boolean
}

export const Header = ({ screenId, defaultState = false }: HeaderProps) => {
  const isNonUsCountry = useSelector(selectIsNonUsCountry)

  return (
    <S.HeaderWrapper>
      <S.HeaderRow>
        <Logo />
        <UserMenu screenId={screenId} defaultState={defaultState} />
      </S.HeaderRow>
      {(isNonUsCountry && !defaultState) && <CybersecurityBanner />}
    </S.HeaderWrapper>
  )
}
